import { Button } from 'primereact/button';
import styled, { css } from 'styled-components';

const HeaderSquareButton = styled(Button)<{
  $isOrange?: boolean;
  $isHighlighted?: boolean;
}>`
  --bg-color: ${(props) => props.theme.colors.secondaryLightGreen30};
  --icon-color: ${(props) => props.theme.colors.primaryGreen};

  background-color: var(--bg-color);
  color: var(--icon-color);
  border: 0;
  border-radius: 4px;
  padding: 0;
  margin-left: 16px;
  justify-content: center;
  && {
    width: 32px;
    height: 32px;
  }
  &&:hover {
    background-color: ${(props) => props.theme.colors.primaryGreen};
    color: ${(props) => props.theme.colors.primaryWhite};
  }
  ${(props) =>
    props.$isHighlighted &&
    css`
      background-color: ${(props) => props.theme.colors.primaryGreen};
      color: ${(props) => props.theme.colors.primaryWhite};
    `}
  > div {
    position: absolute;
  }

  ${(props) =>
    props.$isOrange &&
    css`
      --bg-color: ${(props) => props.theme.colors.primaryOrange};
      --icon-color: ${(props) => props.theme.colors.primaryWhite};
    `}
`;
export default HeaderSquareButton;
